module.exports = __webpack_public_path__ + "static/gallery-tablet-00b8323f0053bf19b441ab07a8e592fe.jpg";